import { COUPON_ACTIONS } from "../actions/couponActions";

const initialState = {
  appliedCoupons: [],
  loading: false,
  error: null,
};

const couponReducer = (state = initialState, action) => {
  switch (action.type) {
    case COUPON_ACTIONS.APPLY_COUPON_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case COUPON_ACTIONS.APPLY_COUPON_SUCCESS:
      // Only allow one coupon at a time - replace existing coupon
      return {
        ...state,
        appliedCoupons: [action.payload], // Replace with new coupon
        loading: false,
        error: null,
      };

    case COUPON_ACTIONS.APPLY_COUPON_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case COUPON_ACTIONS.REMOVE_COUPON:
      return {
        ...state,
        appliedCoupons: state.appliedCoupons.filter(
          (coupon) => coupon.coupon_code !== action.payload
        ),
        error: null,
      };

    case COUPON_ACTIONS.CLEAR_COUPONS:
      return {
        ...state,
        appliedCoupons: [],
        error: null,
      };

    default:
      return state;
  }
};

export default couponReducer;
